"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _ServiceFactory = _interopRequireDefault(require("../ServiceFactory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used as a simple interface for the series gallery service.
 */
var SeriesGalleryServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(SeriesGalleryServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(SeriesGalleryServiceFacade);

  function SeriesGalleryServiceFacade() {
    _classCallCheck(this, SeriesGalleryServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(SeriesGalleryServiceFacade, null, [{
    key: "getApplications",

    /**
     * Fetches and returns series gallery applications.
     *
     * @returns {Promise} Promise object.
     */
    value: function getApplications() {
      var _this = this;

      return this._getCachePromise('seriesgallery') || new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (localized) {
          _ServiceFactory.default.getService('seriesgallery').getApplications(localized.localization.locale).then(function (applications) {
            _this.setCacheItem('seriesgallery', applications);

            resolve(applications);
          }).catch(_this._clearCacheAndReject.bind(_this, reject));
        }).catch(_this._clearCacheAndReject.bind(_this, reject));
      });
    }
    /**
     * Sets cache expire time in ms.
     *
     * @override
     * @param {number} cacheExpireTime Cache expire time in ms.
     */

  }, {
    key: "cacheExpireTime",
    set: function set(cacheExpireTime) {
      this._cacheExpireTime = cacheExpireTime;
    }
    /**
     * Returns cache expire time in ms.
     *  - "0" will disable caching.
     *  - "-1" will cache it the entire session.
     *
     * @override
     * @returns {number} Cache expire time in ms. Returns -1 for localization service by default.
     */
    ,
    get: function get() {
      return typeof this._cacheExpireTime === 'number' ? this._cacheExpireTime : -1;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'SeriesGalleryServiceFacade';
    }
  }]);

  return SeriesGalleryServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = SeriesGalleryServiceFacade;